import Grid from '@mui/material/Grid';
import CVDCardGenetics from '../../../../../../components/Cards/CVDCardGenetics';
import CardElements from '../../../../../../components/TextComps/CardElements';
import Dt1 from "./Dt1/Dt1";
import Dt1_Variants from "./Dt1/Dt1_Variants";
import Dt1_Signal from "./Dt1/Dt1_Signal";
import Dt2 from "./Dt2/Dt2";
import Dt2_Variants from "./Dt2/Dt2_Variants";
import Dt2_Signal from "./Dt2/Dt2_Signal";
import Dia from "./Dia/Dia";
import Dia_Variants from "./Dia/Dia_Variants";
import Dia_Signal from "./Dia/Dia_Signal";

export default function Diabetes() {

return (
<>
<CVDCardGenetics  

cardheadline = 'DIABETES'
content = {<>

                <Grid container> 

                        <CardElements element1={<Dt1 />} element2={<Dt1_Variants />} element3={<Dt1_Signal />} />
                        <CardElements element1={<Dt2 />} element2={<Dt2_Variants />} element3={<Dt2_Signal />} />
                        <CardElements element1={<Dia />} element2={<Dia_Variants  />} element3={<Dia_Signal  />} />

                </Grid>
    </>}   
    
/>    
</>
)};
